import HttpError from 'found/HttpError';
import Route from 'found/Route';
import React from 'react';

import FileViewerPage from 'src/pages/FileViewerPage';

function throw403ForNonInternal({ context }) {
  if (!context.api.viewerIsInternal) throw new HttpError(403);
}

export default (
  <Route getData={throw403ForNonInternal}>
    <Route
      path="file/:imageId"
      Component={FileViewerPage}
      getData={FileViewerPage.getData}
    />
  </Route>
);
